import { motion } from "framer-motion";
import { Check } from "@phosphor-icons/react";
import { IMAGES } from "@/lib/site";

const points = [
  "Multi-Nation certified Family Physician and Coach",
  "Whole-person care across health, wealth, mindset and relationships",
  "Clinical medicine blended with practical, everyday habits",
];

export const About = () => {
  return (
    <section id="about" className="max-w-7xl mx-auto px-6 lg:px-10 py-24 lg:py-32 grid lg:grid-cols-12 gap-14 items-center">
      <motion.div
        initial={{ opacity: 0, x: -40 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 1, ease: [0.16, 1, 0.3, 1] }}
        className="lg:col-span-5 relative"
      >
        <div className="rounded-3xl overflow-hidden border border-brand-line">
          <img src={IMAGES.office} alt="Dr. Tony Ogundipe" className="w-full h-[560px] object-cover object-top" />
        </div>
        <div className="absolute -bottom-6 -right-6 glass border border-brand-line rounded-2xl px-6 py-4">
          <p className="font-serif italic text-2xl text-brand-gold">Dr. Tony</p>
          <p className="overline mt-1">Family Physician · Coach</p>
        </div>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 1, delay: 0.1 }}
        className="lg:col-span-7"
      >
        <span className="overline">Meet your doctor</span>
        <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl font-light text-brand-text mt-4 mb-6">
          Medicine, money and meaning — under one roof.
        </h2>
        <p className="text-brand-dim text-lg leading-relaxed mb-6 max-w-2xl">
          I built TonyBrand29 because health advice ignored the stress of
          finances, and money advice ignored the body carrying it. My practice
          blends clinical rigour with the daily habits that actually move the
          needle in real life.
        </p>
        <ul className="space-y-4">
          {points.map((p) => (
            <li key={p} className="flex items-start gap-3 text-brand-text">
              <span className="mt-1 rounded-full bg-brand-sage/15 p-1">
                <Check size={14} weight="bold" className="text-brand-sage" />
              </span>
              <span className="text-brand-dim">{p}</span>
            </li>
          ))}
        </ul>
      </motion.div>
    </section>
  );
};
